import { render } from "./TradeTermsPageList.vue?vue&type=template&id=f1f94120&scoped=true&ts=true"
import script from "./TradeTermsPageList.vue?vue&type=script&lang=ts"
export * from "./TradeTermsPageList.vue?vue&type=script&lang=ts"

import "./TradeTermsPageList.vue?vue&type=style&index=0&id=f1f94120&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f94120"]])

export default __exports__